export enum LOCAL_STORAGE_KEYS {
  HomepageFrontmatterSections = "homepage-frontmatter-sections",
  SitesIsPrivate = "sites-is-private",
  Email = "email",
  Announcements = "announcements",
  DashboardFeatureTour = "dashboard-identity-feature-tour-v1",
  MediaFeatureTour = "media-identity-feature-tour-v1",
  MediaOnSelectFeatureTour = "media-onselect-identity-feature-tour-v1",
  WorkspaceFeatureTour = "workspace-identity-feature-tour-v1",
  Feedback = "feedback",
  HeroOptionsFeatureTour = "hero-options-feature-tour-v1",
}
